var _rect, _rect2, _rect3, _rect4, _rect5, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 19,
    height: 18,
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "svgWhiteFillOnSidebar svgNoStrokeOnSidebar",
    x: 2,
    y: 14,
    width: 20,
    height: 2,
    fill: "#0973F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "svgWhiteFillOnSidebar svgNoStrokeOnSidebar",
    x: 2,
    y: 8,
    width: 20,
    height: 2,
    fill: "#0973F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "svgWhiteFillOnSidebar svgNoStrokeOnSidebar",
    x: 7,
    y: 10,
    width: 2,
    height: 10,
    fill: "#0973F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "svgWhiteFillOnSidebar svgNoStrokeOnSidebar",
    x: 14,
    y: 10,
    width: 2,
    height: 10,
    fill: "#0973F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgWhiteFillOnSidebar svgNoStrokeOnSidebar",
    d: "M1 32V26H2.4375V28H4.35417V26H5.79167V32H4.35417V29.5H2.4375V32H1ZM8.42708 32V27.5H6.75V26H11.5417V27.5H9.86458V32H8.42708ZM12.5 32V27C12.5 26.7167 12.592 26.479 12.776 26.287C12.96 26.095 13.1874 25.9993 13.4583 26H17.7708C18.0424 26 18.2701 26.096 18.4541 26.288C18.6381 26.48 18.7298 26.7173 18.7292 27V32H17.2917V27.5H16.3333V31H14.8958V27.5H13.9375V32H12.5ZM20.1667 32V26H21.6042V30.5H24V32H20.1667Z",
    fill: "#0973F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlTable);
export default __webpack_public_path__ + "static/media/htmlTable.706edd37.svg";
export { ForwardRef as ReactComponent };